<div class="question {{question_class}}">
  <div class="header {{question_header_class}}">{{t "evaluationResult.question"}}</div>
  <p class="question-text {{question_description_class}}">{{question}}</p>
  <ul class="{{question_list_class}}">
    {{#each allAnswers}}
      <li>
        <p class="description">{{text}}</p>
      </li>
    {{/each}}
  </ul>
</div>
<hr class="divider {{divider_class}}"/>
<div class="answers {{answers_class}}">
  <div class="header {{answers_header_class}}">{{t "evaluationResult.myResults"}}</div>
  {{#if answers}}
    <ul>
      {{#each answers}}
        <li>
          <p class="description">{{text}}</p>
        </li>
      {{/each}}
    </ul>
  {{/if}}
  {{#if answer}}
    {{#with answer}}
      <p class="description">{{text}}</p>
    {{/with}}
  {{/if}}
</div>
